import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f298ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  id: "add-to-list-button"
}, "🔵", -1))
const _hoisted_3 = { id: "task-list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "open-task-actions" }, "☰", -1))
const _hoisted_5 = { class: "button-group" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between","padding":"0.2rem"}
}
const _hoisted_14 = { key: 0 }

import { computed, ref } from 'vue'
import { useStorage } from '@vueuse/core'
import type Task from '@/interfaces/Task'


export default /*#__PURE__*/_defineComponent({
  __name: 'TodoList',
  props: ['selectedTask'],
  emits: ['update:selectedTask'],
  setup(__props, { emit: emits }) {

const props = __props;





const taskToAdd = ref<string>('')
const taskList = useStorage<Task[]>('taskList', [], localStorage)

const addToListInput = ref<HTMLElement | null>()

const indexInsert = ref<number>(0)

const addToList = async (): Promise<void> => {
  if (addToListInput.value == null) return
  if (taskList.value.filter((task: Task) => task.name === taskToAdd.value).length !== 0 || taskToAdd.value.trim().length === 0) {
    addToListInput.value.style.border = '2px dashed red'
    await new Promise(resolve => setTimeout(resolve, 1000))
    addToListInput.value.style.border = ''
    return
  }
  taskList.value.splice(indexInsert.value, 0, { name: taskToAdd.value, done: false })
  indexInsert.value = 0
  taskToAdd.value = ''
}

const moveUp = (index: number): void => {
  if (index === 0) {
    return
  }
  arrayMove(taskList.value, index, index - 1)
}

const moveDown = (index: number): void => {
  if (index + 1 === taskList.value.length) {
    return
  }
  arrayMove(taskList.value, index, index + 1)
}

function arrayMove (arr: Task[], fromIndex: number, toIndex: number) :void {
  const element = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, element)
}

const edit = (task: Task, index: number): void => {
  taskToAdd.value = task.name
  indexInsert.value = index
  taskList.value.splice(index, 1)
}

const completedTasks = computed(() => {
  return taskList.value.filter((task: Task) => task.done).length
})

const totalTasks = computed(() => {
  return taskList.value.length
})

const removeFromList = (task: Task): void => {
  const index = findIndexOfTask(task)
  if (index > -1) {
    taskList.value.splice(index, 1)
  }
  if (props.selectedTask === task) {
    emits('update:selectedTask', null)
  }

  // reset indexInsert to avoid invalid index at submit
  indexInsert.value = 0
}

const findIndexOfTask = (task: Task): number => {
  return taskList.value.indexOf(task)
}

const validate = (task: Task): void => {
  task.done = !task.done
  if (task === props.selectedTask && this !== null) {
    emits('update:selectedTask', null)
  }
}
const select = (task: Task): void => {
  if (props.selectedTask === task) {
    emits('update:selectedTask', null)
  } else if (!task.done) {
    emits('update:selectedTask', task)
  }
}
const emptyList = (): void => {
  if (confirm("You're about to delete all of your tasks.\nAre you sure you want to do that ? 🗑️")) {
    taskList.value = []
  }
}

const isTaskListEmpty = computed(() => {
  return taskList.value.length === 0
})

const isThereUncompletedTask = computed(() => {
  return taskList.value.filter((task: Task) => !task.done).length !== 0
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "todo-list",
    class: _normalizeClass({'uncompleted': isThereUncompletedTask.value || _unref(taskList).length == 0, 'completed': !isThereUncompletedTask.value && _unref(taskList).length !== 0})
  }, [
    _createElementVNode("h2", null, "Task List " + _toDisplayString(isThereUncompletedTask.value ? "📬" : "📭"), 1),
    _createElementVNode("form", {
      onSubmit: _withModifiers(addToList, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "addToListInput",
        ref: addToListInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((taskToAdd).value = $event)),
        type: "text",
        id: "add-to-list-input",
        maxlength: "50"
      }, null, 512), [
        [_vModelText, taskToAdd.value]
      ]),
      _hoisted_2
    ], 40, _hoisted_1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskList), (task, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["task", {'task-done' : task.done, 'task-undone' : !task.done }])
        }, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("button", {
              onClick: ($event: any) => (moveUp(i))
            }, "⬆️", 8, _hoisted_6),
            _createElementVNode("button", {
              onClick: ($event: any) => (moveDown(i))
            }, "⬇️", 8, _hoisted_7),
            _createElementVNode("button", {
              onClick: ($event: any) => (edit(task, i))
            }, "✏️", 8, _hoisted_8),
            _createElementVNode("button", {
              onClick: ($event: any) => (removeFromList(task))
            }, "❌", 8, _hoisted_9),
            _createElementVNode("button", {
              onClick: ($event: any) => (validate(task))
            }, _toDisplayString(task.done ? "✅" : "🟩"), 9, _hoisted_10)
          ]),
          _createElementVNode("span", {
            ref_for: true,
            ref: "itemRefs",
            class: _normalizeClass([{ 'validated': task.done }, "task-name"]),
            onClick: ($event: any) => (select(task))
          }, _toDisplayString(task.name), 11, _hoisted_11),
          (__props.selectedTask === task)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 💎 "))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    (!isTaskListEmpty.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("span", {
            style: _normalizeStyle({ 'color': completedTasks.value === totalTasks.value ? 'green' : 'black' })
          }, [
            _createTextVNode(_toDisplayString(completedTasks.value) + "/" + _toDisplayString(totalTasks.value) + " ", 1),
            (completedTasks.value === totalTasks.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "🎉🐲🐙🦞🐟"))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("button", { onClick: emptyList }, "🗑️")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})